//===================防挂机计时器===============

const preventHangUp = {

  state: {
    //防挂机计时器时间，单位：秒
    timeHangUp:0,
    timeHangUpFuc:null,
  },

  mutations: {

    //设置防挂机计时器
    SET_TIME_HANGUP(state,payload){
      localStorage.setItem('timeHangUp',JSON.parse(payload))
      state.timeHangUp = payload
      // state.timeHangUp = 5
    },

    //打开防挂机计时器
    START_HANGUP(state){
      if(!state.timeHangUpFuc){
        state.timeHangUpFuc = setInterval(()=>{
          state.timeHangUp -= 1;
        },1000)
      }
    },

    //关闭防挂机计时器
    STOP_HANGUP(state){
      clearInterval(state.timeHangUpFuc);
      state.timeHangUpFuc = null;
      // console.log(state.timeHangUp,'防挂机关闭')
    },

    //重置计时器
    RESET_HANGUP(state){
      // state.timeHangUp = 5
      state.timeHangUp = localStorage.getItem('timeHangUp');
    }

  },

};

export default preventHangUp;
